import API from '@Services/apiAxios';
import axios from 'axios';

export const uploadExcelData = async (csvContent: string): Promise<any> => {
  const response = await API.post('/speedboxbot/extract', {
    documentType: 'shipment',
    textContent: csvContent,
  });
  return response.data;
};

export interface PresignedUrlResponse {
  url: string;
  fields: Record<string, string>;
  key: string;
}

export const getUploadUrl = async (file: File): Promise<PresignedUrlResponse> => {
  const { data } = await API.post<PresignedUrlResponse>('/speedboxbot/extract/upload-url', {
    fileName: file.name,
    mimeType: file.type,
  });
  return data;
};

export const uploadToS3 = async (uploadUrlResponse: PresignedUrlResponse, file: File): Promise<void> => {
  const { url, fields } = uploadUrlResponse;
  const formData = new FormData();
  Object.entries(fields).forEach(([key, value]) => {
    formData.append(key, value);
  });
  formData.append('file', file);

  // Use a clean axios instance for the S3 POST request to avoid custom API headers
  await axios.post(url, formData);
};
